import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

const ImageInput = ({ label, folder, name, register, imagen }) => {
    // const [fileName, setFileName] = useState("");
    const [imageUrl, setImageUrl] = useState("");

    let handleChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (e) => {
            setImageUrl(reader.result);
        };
    };

    useEffect(() => {
        if (imagen && imagen != null) {
            setImageUrl(`/images/${folder}/${imagen}`);
        }
    }, []);

    return (
        <Form.Group controlId={name} className="mb-3">
            <Form.Label>{label}</Form.Label>
            <Form.Control
                name={name}
                type="file"
                {...register(name, {
                    onChange: (e) => {
                        handleChange(e);
                    },
                })}
            />
            <img className="previewImage img-fluid" src={imageUrl} />
        </Form.Group>
    );
};

export default ImageInput;
